import { useState } from 'react';
import { Link } from 'react-router-dom';
import { games, categories } from '@/mocks/games';
import type { Game } from '@/mocks/games';

export default function GameShowcase() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredGames: Game[] = activeCategory === 'all'
    ? games
    : games.filter((g) => g.category === activeCategory);

  const hotGames = games.filter((g) => g.isHot).slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-fire-line"></i>
            热门推荐
          </div>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            热门游戏推荐
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            精选最受玩家欢迎的热门游戏，涵盖棋牌、电子、捕鱼、体育竞猜等多个品类
          </p>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                activeCategory === cat.id
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} mr-1.5 text-xs`}></i>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {filteredGames.slice(0, 6).map((game) => (
            <Link
              key={game.id}
              to={`/category/${game.category}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                  {game.isHot && (
                    <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
                      热门
                    </span>
                  )}
                  {game.isNew && (
                    <span className="px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-semibold">
                      新游
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {game.name}
                  </h3>
                  <span className="flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-star-fill text-xs"></i>
                    {game.rating}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {game.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-user-line mr-1"></i>
                    {game.players}玩家
                  </span>
                  <span className="text-xs text-foreground-500">{game.categoryName}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 border border-primary-300 text-primary-600 font-medium rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}